<template>
  <p-vue-panel v-if="item" class="item-panel">
    <template #header>
      <div @click="showData = !showData">
        <span class="p-panel-title"
          >{{ item.ISKey ? __("מפתחות") : item.Type }} {{ __("Purpose") }}
          {{ item.NameTo }}</span
        >
      </div>
    </template>
    <div class="grid">
      <div class="p-d-flex p-flex-column">
        <span>{{ __("Building") }}:</span>
        <span class="item-data">{{ item.fullAddress }}</span>
      </div>
      <div class="p-d-flex p-flex-column">
        <span>{{ __("Unit") }}:</span>
        <span class="item-data">{{ item.unitFullName }}</span>
      </div>
    </div>

    <p-transition-expand>
      <div v-if="showData">
        <div class="grid p-mt-3">
          <div class="p-d-flex p-flex-column">
            <span>{{ __("Recipient") }}:</span>
            <span class="item-data">{{ item.NameTo }}</span>
          </div>
          <div class="p-d-flex p-flex-column">
            <span>{{ __("Recipient phone") }}:</span>
            <span class="item-data">{{ item.PhoneTo }}</span>
          </div>

          <div class="p-d-flex p-flex-column">
            <span>{{ __("Storage Location") }}:</span>
            <span class="item-data">{{ item.StorageLocation }}</span>
          </div>

          <div class="p-d-flex p-flex-column" v-if="!item.ISKey">
            <span>{{ __("Type") }}:</span>
            <span class="item-data">{{ item.Type }}</span>
          </div>
          <div class="p-d-flex p-flex-column">
            <span>{{ __("Sent by") }}:</span>
            <span class="item-data">{{ item.DeliveryFrom }}</span>
          </div>
          <div class="p-d-flex p-flex-column">
            <span>{{ __("Date and time of reception") }}:</span>
            <span class="item-data">{{
              dateFormat(item.DateAndTimeAccepted, true)
            }}</span>
          </div>
          <div class="p-d-flex p-flex-column">
            <span>{{ __("Comment") }}:</span>
            <span class="item-data">{{
              item.CommentAccepted ? item.CommentAccepted : "---"
            }}</span>
          </div>
          <div class="p-d-flex p-flex-column">
            <span>{{ __("security guard") }}:</span>
            <span class="item-data">{{ item.WorkerNameAccepted }}</span>
          </div>
        </div>
        <div class="deliver-title p-mt-3 p-mb-2" v-if="item.IsDelivered">
          {{ __("פירטי איסוף") }}
        </div>
        <div class="grid" v-if="item.IsDelivered">
          <div class="p-d-flex p-flex-column">
            <span>{{ __("Delivered to") }}:</span>
            <span class="item-data">{{ item.CollectingName }}</span>
          </div>
          <div class="p-d-flex p-flex-column">
            <span>{{ __("Delivered by") }}:</span>
            <span class="item-data">{{ item.WorkerNameDelivered }}</span>
          </div>
          <div class="p-d-flex p-flex-column">
            <span>{{ __("Date and time of collection") }}:</span>
            <span class="item-data">{{
              dateFormat(item.DateAndTimeDelivered, true)
            }}</span>
          </div>
          <div class="p-d-flex p-flex-column">
            <span>{{ __("Comment") }}:</span>
            <span class="item-data">{{
              item.CommentDelivered ? item.CommentDelivered : "---"
            }}</span>
          </div>
        </div>
        <div v-if="item.Images && item.Images.length > 0">
          <div class="p-my-4">{{ __("Photos") }}:</div>
          <div v-if="item.Images.length == 1">
            <local-image
              :key="index"
              :image="item.Images[0]"
              :allImages="item.Images"
              :newImageID="null"
              :newImage="null"
            ></local-image>
          </div>
          <div v-else>
            <carousel
              class="card__wrapper"
              :items-to-show="1"
              ref="myCarousel"
              v-model="currentIndex"
              :wrapAround="true"
              :mouseDrag="false"
              :dir="language.dir"
            >
              <slide v-for="(img, slide) in item.Images" :key="slide">
                <local-image
                  :image="img"
                  :allImages="item.Images"
                  :newImageID="null"
                  :newImage="null"
                ></local-image>
              </slide>
              <template #addons="{ slidesCount }">
                <navigation v-if="slidesCount > 1" />
              </template>
            </carousel>
          </div>
        </div>
      </div>
    </p-transition-expand>

    <div class="p-d-flex p-jc-between p-ai-center p-mt-3" style="gap: 10px;">
      <div
        :class="{
          rotate: showData,
        }"
        @click="showData = !showData"
      >
        <i-icon name="arrow" />
      </div>
      <div
        class="p-d-flex p-jc-end"
        style="gap: 10px;"
        v-if="!item.IsDelivered"
      >
        <p-vue-button
          icon="pi pi-pencil"
          class="p-button-rounded p-button-success p-button-outlined"
          @click="editItem"
        />
        <p-vue-button
          class="p-button-rounded p-button-info p-button-outlined"
          @click="collection"
          :label="__('delivery')"
        />
      </div>
    </div>
  </p-vue-panel>
</template>

<script>
import PTransitionExpand from "@/components/partials/p-transition-expand";
import { dateFormat } from "@/services/apointUtil";
import { mapState } from "vuex";
import LocalImage from "@/views/v-service-calls/check-list/image";
import { Carousel, Slide, Navigation } from "vue3-carousel";
export default {
  props: {
    item: {
      type: Object,
    },
  },
  components: {
    PTransitionExpand,
    LocalImage,
    Carousel,
    Slide,
    Navigation,
  },
  emits: ["editItem", "collection", "Deleteitem"],
  data() {
    return {
      showData: false,
      dateFormat,
      currentIndex: 0,
    };
  },
  methods: {
    editItem() {
      this.$emit("editItem");
    },
    collection() {
      this.$emit("collection");
    },
  },
  computed: {
    ...mapState({
      sessionToken: (state) => state.api.sessionToken,
      language: (state) => state.local,
    }),
  },
};
</script>

<style scoped>
.rotate {
  transform: rotate(180deg);
}

:deep(.svg) {
  color: var(--color-success);
  width: 24px;
  height: 24px;
}

.item-data {
  color: var(--color-accent);
}
.deliver-title {
  color: var(--color-accent);
  font-weight: bold;
}

.contact-title {
  font-size: 18px;
  text-decoration: none;
  letter-spacing: 0.51px;
  font-weight: 600;
  color: var(--color-accent);
}

.grid {
  display: grid;
  grid-template-columns: 48% 48%;
  gap: 15px;
  justify-content: space-between;
  align-items: center;
}

:deep(.p-carousel-item) {
  direction: rtl;
}

:deep(.p-carousel-content) {
  direction: ltr;
}

:deep(.p-carousel .p-carousel-indicators .p-carousel-indicator button) {
  width: 0.5rem;
}

:deep(.custom-carousel-hide-one .p-carousel-content .p-carousel-prev),
:deep(.custom-carousel-hide-one .p-carousel-content .p-carousel-next),
:deep(.custom-carousel-hide-one .p-carousel-content .p-carousel-indicators) {
  display: none;
}

.button {
  width: 100%;
}

:deep(.p-carousel .p-carousel-content .p-carousel-prev, .p-carousel
    .p-carousel-content
    .p-carousel-next) {
  margin: 0;
  width: 0.8rem;
  height: 0.8rem;
}
:deep(.carousel__slide) {
  display: block;
}

.he .card__wrapper {
  text-align: right;
}

.en .card__wrapper {
  text-align: left;
}

:deep(.carousel__prev),
:deep(.carousel__next) {
  background-color: #fff;
  border: 1px solid var(--color-success);
}

:deep(.carousel__icon) {
  fill: var(--color-success);
}
</style>
